import { accumulateCaseRefs } from '@/utils';
import { CHAT_HISTORY_LIST_TAG, LIST_QUERY_CACHE_TTL_SECONDS } from '../constants';
import { api } from '../core';
import type { GetChatHistoryResponse } from './getChatHistory';

/** The largest `page_size` the chats endpoint accepts. */
export const CHATS_MAX_PAGE_SIZE = 400;

const getChatHistoryCaseReferencesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /** Every case reference on the user's chats, for the History filter; the BE has no filter-options route for chats. */
    getChatHistoryCaseReferences: builder.query<string[], void>({
      queryFn: async (_arg, _api, _extraOptions, baseQuery) => {
        let caseRefs = new Set<string>();

        for (let pageIndex = 0; ; pageIndex++) {
          const result = await baseQuery({
            url: 'chats',
            method: 'GET',
            params: { page_index: pageIndex, page_size: CHATS_MAX_PAGE_SIZE },
          });

          if (result.error) {
            return { error: result.error };
          }

          const { chats, numberOfResults } = result.data as GetChatHistoryResponse;
          caseRefs = accumulateCaseRefs(chats, caseRefs);

          if (chats.length < CHATS_MAX_PAGE_SIZE || (pageIndex + 1) * CHATS_MAX_PAGE_SIZE >= numberOfResults) {
            break;
          }
        }

        return { data: Array.from(caseRefs).sort() };
      },
      providesTags: () => [{ type: CHAT_HISTORY_LIST_TAG }],
      extraOptions: { maxRetries: 3 },
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useGetChatHistoryCaseReferencesQuery } = getChatHistoryCaseReferencesApi;
